import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Tracks the page the user was on right before they entered /transport, so the
// header's Transport/Delivery icon can temporarily become a "back to <that
// page>" icon while viewing Transport, then revert to the normal Transport
// icon the moment the user leaves Transport by ANY means (the back icon, a
// different nav pill, browser back, etc).
const TransportReturnContext = createContext({ returnPath: null });

export const TransportReturnProvider = ({ children }) => {
  const location = useLocation();
  const [returnPath, setReturnPath] = useState(null);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currPath = location.pathname;
    const wasOnTransport = prevPath.startsWith('/transport');
    const isOnTransport = currPath.startsWith('/transport');

    if (isOnTransport && !wasOnTransport) {
      setReturnPath(prevPath || '/');
    } else if (!isOnTransport && wasOnTransport) {
      setReturnPath(null);
    }
    prevPathRef.current = currPath;
  }, [location.pathname]);

  return (
    <TransportReturnContext.Provider value={{ returnPath }}>
      {children}
    </TransportReturnContext.Provider>
  );
};

export const useTransportReturn = () => useContext(TransportReturnContext);
